import { Button, Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody } from '@chakra-ui/react'

interface IProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  textHeader?: string
  textBody?: string
  textConfirm?: string
  textCancel?: string
}

export default function ConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  textHeader,
  textBody,
  textConfirm,
  textCancel
}: IProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{textHeader ?? 'Confirmar Ação'}</ModalHeader>
        <ModalBody>{textBody ?? 'Deseja realmente confirmar esta ação?'}</ModalBody>
        <ModalFooter>
          <Button colorScheme="blue" mr={3} onClick={onConfirm}>
            {textConfirm ?? 'Confirmar'}
          </Button>
          <Button variant="ghost" onClick={onClose}>
            {textCancel ?? 'Cancelar'}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
